var exports = {
  "h": "DesktopNotificationNagbar.module__description___M0haU0",
};

module.exports = exports;
